import React from "react";

import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  secondaryIcon: {
    height: "30px",
    width: "30px",
    borderRadius: "60px",
    backgroundColor: theme.palette.dark.main,
    "&:hover": {
      backgroundColor: theme.palette.dark.light,
    },
  },
}));

const KMKBackButton = ({ handleClick }) => {
  const { classes } = useStyles();

  return (
    <IconButton className={classes.secondaryIcon} onClick={handleClick} sx={{ mr: 2 }}>
      <ArrowBackIcon style={{ color: "white", height: "20px", width: "20px" }} />
    </IconButton>
  );
};

export default React.memo(KMKBackButton);
